import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// Components
import Link from "../../elements/link";
import Image from "../../elements/image";
import Icon from "../../elements/icon";
import { toLowerCaseHyphenated } from "../../utils/siteUtils";

const ProductCard = ({
  productName,
  productBrand,
  formattedPrice,
  discountedFormattedPrice,
  link,
  backgroundImage,
  spuId,
  onCardClick
}) => (
  <Link
    className="card__content"
    url={toLowerCaseHyphenated(link.url)}
    callback={onCardClick}
  >
    <Image {...backgroundImage}></Image>
    <div className="card__overlay" ga-product-id={spuId} />
    <div className="card__overlay-content">
      <span className="card__learn-more-title">{productBrand}</span>
      <span className="card__learn-more-subtitle">{productName}</span>
    </div>
    <div className="card__bottom-row">
      <div className="card__price-container">
        <span
          className={classNames("card__price", {
            "card__price--new": discountedFormattedPrice
          })}
        >
          {discountedFormattedPrice || formattedPrice}
        </span>
        {discountedFormattedPrice && (
          <span className="card__price card__price--original">
            {formattedPrice}
          </span>
        )}
      </div>
      <span
        className={classNames("card__link-arrow", {
          "card__link-arrow--discount": discountedFormattedPrice
        })}
      >
        <Icon name="ArrowForward" />
      </span>
    </div>
  </Link>
);

ProductCard.propTypes = {
  productName: PropTypes.string.isRequired,
  productBrand: PropTypes.string.isRequired,
  formattedPrice: PropTypes.string.isRequired,
  discountedFormattedPrice: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string.isRequired
  }).isRequired,
  backgroundImage: PropTypes.shape(Image.propTypes).isRequired
};

export default ProductCard;
